const LeadFuncState = {
  // getDynamicStatusTotals: async (data) => {
  //   const totals = {};
  //   const today = new Date().toDateString(); // e.g., "Fri Dec 05 2025"

  //   await data.forEach((record) => {
  //     const statuses = record.statusCounts || {};
  //     const recordDate = new Date(record.receivedOn).toDateString();

  //     // 🔹 Normal status counting
  //     Object.entries(statuses).forEach(([status, count]) => {
  //       totals[status] = (totals[status] || 0) + count;
  //       totals.total = (totals.total || 0) + count;
  //     });

  //     // 🔹 If data belongs to today's date → count as "New"
  //     if (recordDate === today) {
  //       const todayTotal =
  //         Object.values(statuses).reduce((sum, val) => sum + val, 0) || 1;
  //       totals["New"] = (totals["New"] || 0) + todayTotal;
  //     }
  //   });

  //   return totals;
  // },

  // getDynamicSourceTotals: async (data) => {
  //   const totals = {};
  //   const today = new Date().toDateString(); // e.g. "Fri Dec 05 2025"

  //   data.forEach((record) => {
  //     const leadSource = record.leadSource || "Unknown";
  //     const recordDate = new Date(record.receivedOn).toDateString();

  //     // 🔹 Normal leadSource counting
  //     totals[leadSource] = (totals[leadSource] || 0) + (record.totalLeads || 1);
  //     totals.total = (totals.total || 0) + (record.totalLeads || 1);

  //     // 🔹 If today's data → add to "New"
  //     if (recordDate === today) {
  //       totals["New"] = (totals["New"] || 0) + (record.totalLeads || 1);
  //     }
  //   });

  //   return totals;
  // },

  // Single Combined Function
  getformatUserPerformanceData: (userwiseData) => {
    // Step 1: convert user data (arrays) to status totals
    const getUserwiseStatusTotals = (groupedByUser) => {
      const userwiseTotals = {};
      const today = new Date().toDateString();

      Object.entries(groupedByUser || {}).forEach(([user, records]) => {
        const totals = {};

        records.forEach((record) => {
          const statusKey = record.status || "Unknown";
          totals[statusKey] = (totals[statusKey] || 0) + 1;
          totals.total = (totals.total || 0) + 1;

          // check if record received today
          const recordDate = new Date(record.receivedOn).toDateString();
          if (recordDate === today) {
            totals["New"] = (totals["New"] || 0) + 1;
          }
        });

        userwiseTotals[user] = totals;
      });

      return userwiseTotals;
    };

    // Step 2: summarize userwise totals
    const userwiseTotals = getUserwiseStatusTotals(userwiseData);

    // Step 3: format for frontend table
    const defaultFields = {
      facebook_leads: "--",
      cpl_per_user: "--",
      no_of_meeting_done: "--",
      no_of_site_visit_done: "--",
      no_of_invoice: "--",
      total_revenue: "--",
      roi: "--",
    };

    return Object.entries(userwiseTotals || {}).map(
      ([userName, stats], index) => {
        const facebookLeads = stats["Facebook"] ?? stats.Facebook ?? 0;
        const meetingsDone =
          stats["Meeting Done"] ??
          stats["Meetings Done"] ??
          stats.meeting_done ??
          0;
        const siteVisitDone =
          stats["Site Visit Done"] ??
          stats["Site Visits Done"] ??
          stats.site_visit_done ??
          0;
        const invoiceCount =
          stats["Invoiced"] ?? stats["Booked"] ?? stats.no_of_invoice ?? 0;
        const totalRevenue = stats["Total Revenue"] ?? stats.total_revenue ?? 0;
        const roi =
          stats["ROI"] ??
          stats.roi ??
          (totalRevenue && facebookLeads
            ? ((totalRevenue / (facebookLeads * 100)) * 100).toFixed(2) + "%"
            : "--");

        return {
          key: index + 1,
          user_name: userName,
          ...defaultFields,
          facebook_leads: facebookLeads || "--",
          cpl_per_user:
            facebookLeads > 0
              ? (totalRevenue / facebookLeads).toFixed(2)
              : "--",
          no_of_meeting_done: meetingsDone || "--",
          no_of_site_visit_done: siteVisitDone || "--",
          no_of_invoice: invoiceCount || "--",
          total_revenue: totalRevenue || "--",
          roi,
        };
      }
    );
  },

  // LeadReport
  getformatLeadReportData: async (userwiseTotals) => {
    const defaultFields = {
      total: "--",
      new: "--",
      pending: "--",
      overdue: "--",
      expression_of_nterest: "--",
      Callback: "--",
      meetings_scheduled: "--",
      site_visits_scheduled: "--",
      booked: "--",
      booking_cancel: "--",
      not_interested: "--",
      dropped: "--",
    };

    return Object.entries(userwiseTotals || {}).map(
      ([agentName, stats], index) => {
        return {
          key: index + 1,
          agent_name: agentName,
          ...defaultFields, // start with all "--"
          // then override if value exists in userwiseTotals
          total: stats.total ?? "--",
          new: stats.New ?? "--",
          pending: stats.Pending ?? "--",
          overdue: stats.Overdue ?? "--",
          expression_of_nterest: stats["Expression Of Interest"] ?? "--",
          Callback: stats.Callback ?? "--",
          meetings_scheduled: stats["Schedule Meeting"] ?? "--",
          site_visits_scheduled: stats["Schedule Site Visit"] ?? "--",
          booked: stats.Invoiced ?? stats.Booked ?? "--",
          booking_cancel: stats["Booking Cancel"] ?? "--",
          not_interested: stats["Not Interested"] ?? "--",
          dropped: stats.Dropped ?? "--",
        };
      }
    );
  },

  // Team Performance
  getformatTeamPerformanceData: async (userwiseTotals) => {
    const defaultFields = {
      assigned_leads: "--",
      site_visit_done: "--",
      meeting_done: "--",
      booked: "--",
    };

    return Object.entries(userwiseTotals || {}).map(
      ([agentName, stats], index) => {
        return {
          key: index + 1,
          agent_name: agentName,
          ...defaultFields,
          assigned_leads:
            stats["Assigned Leads"] ??
            stats.total ??
            stats.assigned_leads ??
            "--",
          site_visit_done:
            stats["Site Visit Done"] ?? stats.site_visit_done ?? "--",
          meeting_done: stats["Meeting Done"] ?? stats.meeting_done ?? "--",
          booked:
            stats["Invoiced"] ?? stats["Booked"] ?? stats.Invoiced ?? "--",
        };
      }
    );
  },
};

export default LeadFuncState;
